import { render, staticRenderFns } from "./SAKurukuru.html?vue&type=template&id=385afb6e&scoped=true&"
import script from "./SAKurukuru.ts?vue&type=script&lang=ts&"
export * from "./SAKurukuru.ts?vue&type=script&lang=ts&"
import style0 from "./SAKurukuru.css?vue&type=style&index=0&id=385afb6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385afb6e",
  null
  
)

export default component.exports